<template>
    <div class="member_home">
        <div class="menu_btn">
            <div class="menu_btn_div tenant_payment_btn">
                <button>
                    <router-link :to="{ name: 'TenantPaymentContent' }">
                        房租繳費
                    </router-link>
                </button>
            </div>
            <div class="menu_btn_div add_stored_value_btn">
                <button>
                    <router-link :to="{ name: 'AddStoredValue' }">
                        線上儲值
                    </router-link>
                </button>
            </div>
        </div>
        <div class="menu_btn">
            <div class="menu_btn_div maintain_btn">
                <button>
                    <router-link :to="{ name: 'MaintainList' }">
                        維修通報
                    </router-link>
                </button>
            </div>
            <div class="menu_btn_div tenant_mail_btn">
                <div class="mail_length" v-show="mail_length != 0">
                    {{mail_length}}
                </div>
                <button>
                    <router-link :to="{ name: 'MemberMailList' }">
                        郵件訊息
                    </router-link>
                </button>
            </div>
            <div class="menu_btn_div tenant_feedback_btn">
                <button>
                    <router-link :to="{ name: 'TenantFeedback' }">
                        意見反映
                    </router-link>
                </button>
            </div>
        </div>
        <!-- 儲值餘額&儲值 -->
        <!-- <div class="each_title">
            <h3>儲值</h3>
        </div>
        <div class="stored_value">
            <div class="balance">
                <p>卡片餘額：</p>
                <p>{{ stored_value }}</p>
            </div>
            <div class="stored">
                <button>
                    <router-link :to="{ name: 'AddStoredValue' }">
                        更多
                    </router-link>
                </button>
            </div>
        </div>
        <hr> -->
        <!-- 房租交費狀況 -->
        <!-- <div class="each_title">
            <h3>房租交費</h3>
        </div>
        <div class="rent_cost">
             <table>
                <thead>
                    <tr>
                        <th>繳交月份</th>
                        <th>應繳金額</th>
                        <th>已繳金額</th>
                        <th>聯絡人</th>
                        <th>連絡電話</th>
                        <th>狀態</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-show="tenant_payment_content.length > 0" v-for="item in tenant_payment_content" :key="item.id">
                        <td>{{item.payment_time}}</td>
                        <td>{{item.amount_payable}}</td>
                        <td>{{item.actual_payment_amount}}</td>
                        <td>{{item.emergency_contact}}</td>
                        <td>{{item.emergency_phone}}</td>
                        <td :style="item.pay_status == 0 ? 'color:red;' : ''">
                            {{pay_status[item.pay_status]}}
                        </td>
                    </tr>
                    <tr v-show="tenant_payment_content.length <= 0">
                        <td colspan="6">目前無資料</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="payment_btn">
            <button>
                <router-link :to="{ name: 'TenantPaymentContent' }">
                    更多
                </router-link>
            </button>
        </div>
        <hr> -->
        <!-- 房間資料 -->
        <div class="each_title">
            <h3>房間資料</h3>
        </div>
        <div class="building_data">
            <div class="house_number">
                <span>戶號：</span>
                <span>{{ building_data.house_number }}</span>
            </div>
            <div class="house_passwd">
                <span>密碼：</span>
                <span class="change_password_ipt">
                    <!-- {{ building_data.house_passwd }} -->
                    <input type="text" v-model="this_passwd">
                </span>
                <span class="change_password_btn">
                    <button class="change_password" @click="change_password(building_data.id)">
                        變更
                    </button>
                </span>
            </div>
            <div class="parking_space_no">
                <span>車位號：</span>
                <span>{{ building_data.parking_space_no }}</span>
            </div>
            <div class="house_address">
                <span>地址：</span>
                <span>{{ building_data.house_address }}</span>
            </div>
        </div>
        <hr>
        <!-- 租戶資料 -->
        <div class="each_title">
            <h3>租戶資料</h3>
        </div>
        <div class="stored_value">
            <div class="balance" style="margin: 0px;">
                <h4>儲值餘額：</h4>
                <p>{{ stored_value }}</p>
            </div>
        </div>
        <div class="member_user">
            <div class="user_data">
                <div class="user_main">
                    <div class="user_data_name">
                        <div>姓名：</div>
                        <label>
                            <input type="text" v-model="user_data.user_name" disabled>
                        </label>
                    </div>
                    <div class="urgent_phone">
                        <div>緊急聯絡電話：</div>
                        <label>
                            <input type="text" v-model="user_data.urgent_phone" disabled>
                        </label>
                    </div>
                    <div class="car_number">
                        <div>車牌號碼：</div>
                        <label>
                            <input type="text" v-model="user_data.car_number" disabled>
                        </label>
                    </div>
                    <div class="now_demb_kw">
                        <div>簽約時度數：</div>
                        <label>
                            <input type="text" v-model="user_data.lease_demb_kw" disabled>
                        </label>
                    </div>
                    <div class="now_demb_kw">
                        <div>目前總度數：</div>
                        <label>
                            <input type="text" v-model="demb.now_demb_kw" disabled>
                        </label>
                    </div>
                    <div class="now_demb_kw">
                        <div>租約起：</div>
                        <label>
                            <input type="text" v-model="user_data.lease_start" disabled>
                        </label>
                    </div>
                    <div class="now_demb_kw">
                        <div>租約訖：</div>
                        <label>
                            <input type="text" v-model="user_data.lease_end" disabled>
                        </label>
                    </div>
                    <div class="now_demb_kw">
                        <div>總承租天數：</div>
                        <label>
                            <input type="text" v-model="user_data.lease_days" disabled>
                        </label>
                    </div>
                    <div class="user_data_phone">
                        <div>租戶電話：</div>
                        <label>
                            <input type="text" v-model="user_data.user_phone">
                        </label>
                    </div>
                    <div class="user_data_mail">
                        <div>Mail：</div>
                        <label>
                            <input type="text" v-model="user_data.user_email">
                        </label>
                    </div>
                </div>
                <div>
                    <!-- <div class="user_data_subscribed">
                        <span>訂閱狀態：</span>
                        <button class="subscribed_n" v-if="user_data.subscribed == 1" @click="subscribed_up(user_data.id, 0)">
                            取消訂閱
                        </button>
                        <button class="subscribed_y" v-else  @click="subscribed_up(user_data.id, 1)">
                            訂閱
                        </button>
                    </div> -->
                    <!-- <div class="user_data_lease_days">
                        <span>承租天數：</span>
                        <span>{{ user_data.lease_days }}天</span>
                    </div> -->
                    <!-- 金額? -->
                    <div class="user_data_updata">
                        <button class="subscribed_y" @click="emergency_up(user_data.id)">
                            更新資料
                        </button>
                    </div>
                </div>
            </div>
            <hr style="border-style:dashed;">
            <h3>同居親友</h3>
            <div v-show="other_users.length == 0 || other_users.length <= 3 || other_users.error">
                <button class="add_other_users">
                    <router-link :to="{ name: 'AddOtherUsers' }">
                        新增同居親友資料
                    </router-link>
                </button>
            </div>
            <div v-show="other_users.length >= 1" class="other_users" v-for="(other_user, idx) in other_users" :key="idx">
                <div>
                    <div class="other_users_name">
                        <label>
                            姓名：
                            <input type="text" v-model="other_user.other_user_name">
                        </label>
                    </div>
                    <div class="other_users_phone">
                        <label>
                            電話：
                            <input type="text" v-model="other_user.other_user_phone">
                        </label>
                    </div>
                </div>
                <div>
                    <button class="subscribed_d" @click="other_users_del(other_user.id)">
                        刪除
                    </button>
                </div>
            </div>
        </div>
        <!-- <hr>
        <div class="to_tenantFeedback">
            <button class="tenantFeedback_btn">
                <router-link :to="{ name: 'TenantFeedback' }">
                    租戶意見反映
                </router-link>
            </button>
        </div>
        <div class="tenantFeedback_main">
            <div>
                <div class="tenantFeedback_main_title">
                    <span>意見內容</span>
                    <span>回復內容</span>
                </div>
                <div class="tenantFeedback_main_content" v-for="feedback in tenant_feedback" :key="feedback.id">
                    <div><small>反映人：{{feedback.user_name}}&emsp;反映時間：{{feedback.create_time}}</small></div>
                    <textarea disabled :placeholder="feedback.content"></textarea>
                    <textarea disabled :placeholder="feedback.reply_content"></textarea>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import "@/assets/css/member/memberHome.css";

export default {
    name: 'MemberHome',
    data() {
        return {
            stored_value: '6666',
            tenant_payment_content: '',
            pay_status: ['未繳', '已繳'],
            rent_cost: '',
            building_data: {},
            user_data: {},
            demb: {},
            other_users: [],
            tenant_feedback: [],
            mail_length: '',
            this_passwd: ''
        };
    },
    components: {

    },
    filters: {},
    beforeMount: function () {
        if (this.$route.name == 'MemberHome' && !localStorage.getItem('house_number') && this.$store.state.house_number == null) {
            this.$router.push({ name: 'Login' });
        } else {
            const getData = new FormData();
            getData.append('CMD' , 'FrontMemberHome');
            if (localStorage.getItem('house_number') != null) {
                getData.append('house_number' , localStorage.getItem('house_number'));
            }
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
            .then(response => {
                // console.log(response);

                const get_datas = response.data;

                this.tenant_payment_content = get_datas.tenant_payment_content;
                this.building_data = get_datas.building_data;
                this.this_passwd = get_datas.building_data.house_passwd;
                this.user_data = get_datas.user_data;
                this.demb = get_datas.demb;
                this.other_users = get_datas.other_users;
                this.tenant_feedback = get_datas.tenant_feedback;
                this.mail_length = get_datas.mail_length.length;
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    methods: {
        subscribed_up(id, up_status) {
            console.log(id);
            console.log(up_status);
        },
        change_password (id) {
            var yes_up = confirm('您確定變更密碼嗎?');
            if (yes_up) {
                const change_password = new FormData();
                change_password.append('CMD', 'FrontMemberHomeUpdataTenantDataEmergency');
                change_password.append('house_number', localStorage.getItem('house_number'));
                change_password.append('type', 'change_password');
                change_password.append('id', id);
                change_password.append('house_passwd', this.this_passwd);
                this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, change_password)
                .then(response => {
                    // console.log(response);
                    if (response.data.result == true) {
                        alert('變更成功');
                        location.reload();
                    } else {
                        alert(response.data.error);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        emergency_up (idx) {
            // console.log(this.user_data);
            var yes_up = confirm('您確定更新此資料嗎?');
            if (yes_up) {
                const emergency_up = new FormData();
                emergency_up.append('CMD', 'FrontMemberHomeUpdataTenantDataEmergency');
                emergency_up.append('house_number', localStorage.getItem('house_number'));
                emergency_up.append('id', idx);
                emergency_up.append('user_phone', this.user_data.user_phone);
                emergency_up.append('user_email', this.user_data.user_email);
                this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, emergency_up)
                .then(response => {
                    // console.log(response);
                    if (response.data.result == true) {
                        alert('更新成功');
                        location.reload();
                    } else {
                        alert(response.data.error);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        other_users_del (idx) {
            var yes_del = confirm('你確定刪除嗎?');
            if (yes_del) {
                const del_other_users = new FormData();
                del_other_users.append('CMD', 'FrontMemberHomeDelOtherUsers');
                del_other_users.append('house_number', localStorage.getItem('house_number'));
                del_other_users.append('id', idx);
                this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, del_other_users)
                .then(response => {
                    // console.log(response);
                    if (response.data.result == true) {
                        alert('刪除成功');
                        location.reload();
                    } else {
                        alert(response.data.error);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
            }
        }
    },
    mounted: function () {},
};
</script>

<style>

</style>
